import {NgModule} from '@angular/core';

import {CheckboxTreeNodeComponent} from './index';
import {IonicModule} from 'ionic-angular';
import {BaseTreeNodeModule} from '../base-tree-node/base-tree-node.component.module';

/**
 * Module for the CheckboxTreeNodeModule
 * @class
 */
@NgModule({
  declarations: [CheckboxTreeNodeComponent],
  exports: [CheckboxTreeNodeComponent],
  imports: [IonicModule, BaseTreeNodeModule],
  providers: [],
})
export class CheckboxTreeNodeModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tree/tree-node/checkbox-tree-node/checkbox-tree-node.component.module.ts